
module.exports =  require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/engine.io-client/index.js
 ** module id = 714
 ** module chunks = 0
 **/